import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import KonfiguracjaHeader from "../../../../shared/headers/KonfiguracjaHeader";
import PojazdyForm from "./components/PojazdyForm";
import PojazdyTable from "./components/PojazdyTable";
import ReactNotify from 'react-notify';
import PojazdyService from "./PojazdyService";
import ScrollUtilities from "../../../../utilities/ScrollUtilities";

export default class PojazdyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pojazdy: [],
            pojazd: null,
            pokazFormularz: false,
        };
        this.pobierzPojazdy = this.pobierzPojazdy.bind(this);
        this.pokazFormularz = this.pokazFormularz.bind(this);
        this.zamknijFormularz = this.zamknijFormularz.bind(this);
        this.onClickUsun = this.onClickUsun.bind(this);
        this.onClickZapisz = this.onClickZapisz.bind(this);
        this.onClickEdytuj = this.onClickEdytuj.bind(this);
    }

    componentDidMount() {
        this.pobierzPojazdy();
    }

    pobierzPojazdy() {
        PojazdyService.getPojazdy().then(function (response) {
            this.setState({pojazdy: response.data.content})
        }.bind(this))
    }

    pokazFormularz() {
        this.setState({pokazFormularz: true})
        ScrollUtilities.scrollToTop()
    }

    zamknijFormularz() {
        this.setState({pokazFormularz: false, pojazd: null})
    }

    onClickEdytuj(obj) {
        this.pokazFormularz();
        this.setState({pojazd: obj})
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc pojazd: ' + obj.marka + ' ' + obj.model + ' o rejestracji: ' + obj.nrRej)) {
            PojazdyService.deletePojazd(obj.idPo).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunięto pojazd', "", 3000)
                    this.pobierzPojazdy();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas usuwania pojazdu', "", 3000)
                }
            }.bind(this))

        }
    }

    onClickZapisz(obj, czyEdycja) {
        if (czyEdycja) {
            PojazdyService.editPojazd(this.state.pojazd.idPo, obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie edytowano pojazd', "", 3000)
                    this.pobierzPojazdy();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas edycji pojazdu', "", 3000)
                }
            }.bind(this))
        }
        else {
            PojazdyService.addPojazd(obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie dodano pojazd', "", 3000)
                    this.pobierzPojazdy();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas dodawania pojazdu', "", 3000)
                }
            }.bind(this))
        }

        this.zamknijFormularz();
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'PojazdyContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/zarzadzanie-zasobami',
                                    text: 'Zarządzanie zasobami'
                                }, {addressUrl: '/konfiguracja/zarzadzanie-zasobami/pojazdy', text: 'Pojazdy'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz} history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <TopIf isTrue={!Boolean(this.state.pokazFormularz)}>
                                <KonfiguracjaHeader pokazFormularz={this.pokazFormularz} tekstDodaj={'Dodaj pojazd'} pokazButtonSzukaj={false}/>
                            </TopIf>
                            <TopIf isTrue={Boolean(this.state.pokazFormularz)}>
                                <PojazdyForm handleClickAnuluj={this.zamknijFormularz}
                                             handleClickZapisz={this.onClickZapisz}
                                             pojazd={this.state.pojazd}
                                />
                            </TopIf>
                            <PojazdyTable data={this.state.pojazdy}
                                          wlaczSzukanie={true}
                                          handleEdytuj={this.onClickEdytuj}
                                          handleUsun={this.onClickUsun}
                            />
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/pojazdy/PojazdyContainer.js